export default __webpack_public_path__ + "static/media/cif-cy.1f522375.svg";